export * from './predstInfoDossier.component';
